import {
  DataProvider,
  GetListResult,
  GetManyParams,
  GetManyResult,
  GetOneParams,
  GetOneResult,
} from 'react-admin'
import { PDF_PRINTER_DEFINITIONS_URL } from '../../api-urls'
import { get, getWithPagination } from '../../common/fetch.utils'
import {
  filterParamsComposer,
  queryParamsComposer,
} from '../../common/get-by-conditions.utils'
import { TicketAPIGetListParams } from '../../common/ticket-api-get-list.params'
import { PDFPrinterDefinitionsDto } from '../../dto/pdf-printer-definitions.dto'
import filterMapper from './pdf-printer-definitions-filter.mapper'
import { mapSortPDFDefinitionsParam } from './pdf-printer-definitions-sort.mapper'

const provider = {
  getList: async (
    resource: string,
    { filter, sort, pagination }: TicketAPIGetListParams,
  ): Promise<GetListResult<PDFPrinterDefinitionsDto>> => {
    const filterParams = `o=>${filterParamsComposer('o', filter, filterMapper)}`
    const pathParams = queryParamsComposer(
      sort,
      pagination,
      mapSortPDFDefinitionsParam,
    )
    const path = `/${filterParams}${(pathParams && `?${pathParams}`) || ''}`

    const {
      data,
      range: { total },
    } = await getWithPagination<PDFPrinterDefinitionsDto[]>(
      `${PDF_PRINTER_DEFINITIONS_URL}/GetByConditions`,
      path,
    )

    return Promise.resolve({
      data,
      total,
    })
  },
  getOne: async (
    resource: string,
    { id }: GetOneParams,
  ): Promise<GetOneResult<PDFPrinterDefinitionsDto>> => {
    const data = await get<PDFPrinterDefinitionsDto>(
      PDF_PRINTER_DEFINITIONS_URL,
      `/${id}`,
    )
    return Promise.resolve({
      data,
    })
  },
  getMany: async (
    resource: string,
    { ids }: GetManyParams,
  ): Promise<GetManyResult<PDFPrinterDefinitionsDto>> => {
    const data = await get<PDFPrinterDefinitionsDto[]>(
      PDF_PRINTER_DEFINITIONS_URL,
      `/GetByConditions/o=>new int[] {${ids.toString()}}.Contains(o.Id)`,
    )
    return Promise.resolve({ data })
  },
} as DataProvider

export default provider
